import { useTranslation } from "react-i18next";
import RobinPage from "../components/RobinPage";
import { useAppContext } from "../context/app/context";
import {
  DescriptionsProps,
  Descriptions,
  Space,
  Button,
  Typography,
  Spin,
} from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import ChangePasswordModal from "../components/modals/ChangePasswordModal";
import { useGetMyUserQuery } from "../graphql/generated/hooks";

function Profile() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useAppContext();
  const [changePasswordModalVisible, setChangePasswordModalVisible] =
    useState(false);
  const { data, loading, refetch } = useGetMyUserQuery();

  const items: DescriptionsProps["items"] = [
    {
      key: "1",
      label: "Name",
      children: data?.getMyUser?.name || "",
    },
    {
      key: "2",
      label: "Email",
      children: data?.getMyUser?.email || "",
    },
    {
      key: "3",
      label: "Phone Number",
      children: data?.getMyUser?.phoneNumber || "",
    },
  ];

  return (
    <RobinPage
      title={t("title.profile")}
      actions={
        <Space size="large">
          <Typography.Link
            onClick={() => {
              refetch();
            }}
          >
            <ReloadOutlined />
          </Typography.Link>
          <Button
            onClick={() => {
              setChangePasswordModalVisible(true);
            }}
          >
            {t("button.change_password")}
          </Button>
          <Button
            onClick={() => {
              navigate(`/profile/update`);
            }}
          >
            {t("button.update_profile")}
          </Button>
        </Space>
      }
    >
      {loading ? <Spin /> : <Descriptions items={items} />}
      <ChangePasswordModal
        isOpen={changePasswordModalVisible}
        close={() => {
          setChangePasswordModalVisible(false);
        }}
      />
    </RobinPage>
  );
}

export default Profile;
